import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { TPVServices } from '../../../tpv/services';

/**
 * Generated class for the TpvTicketSelectedListTicketPrintPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-configuration-printers-native-print',
    templateUrl: 'configuration-printers-native-print.html',
})
export class ConfigurationPrintersNativePrintPage {
    @Input() selected_list: any;
    footer: any;
    header: any;
    date:any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals,
        public tpvServices: TPVServices) {
            this.date= new Date();
    }

    calculateVariations(units, price, variation_add) {
        return (parseFloat(units) * parseFloat(price)) + parseFloat(variation_add)
    }

}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-thermal-printers/configuration-printers-native-print/configuration-printers-native-print.ts